import type { ListType } from '../models/app';
import type { TableColumnType } from '../models/table';

export const abTestStatusList: ListType[] = [
  { id: 2, key: 'in_progress', label: 'In Progress' },
  { id: 3, key: 'ready', label: 'Ready' },
  { id: 4, key: 'stopped', label: 'Stopped' },
  { id: 5, key: 'completed', label: 'Completed' },
];

export const abTestStatusListWithAny: ListType[] = [{ id: 1, key: '', label: 'Any' }, ...abTestStatusList];

export const abTestColumns: TableColumnType[] = [
  { label: 'ID', field: 'id', width: 60, isCenterAlign: true },
  { label: 'Name', field: 'name', width: 180 },
  { label: 'Status', field: 'status', width: 100 },
  { label: 'Description', field: 'description', width: 180 },
  { label: 'Type', field: 'type', width: 80 },
  { label: 'Start At', field: 'startDate', width: 180, isCenterAlign: true, isDateField: true },
  { label: 'End At', field: 'endDate', width: 180, isCenterAlign: true, isDateField: true },
  { label: 'Deactivation At', field: 'deactivateDate', width: 180, isCenterAlign: true, isDateField: true },
  { label: 'Created At', field: 'createdAt', width: 180, isCenterAlign: true, isDateField: true },
  { label: 'End After # Users', field: 'endAfterNumUsers', width: 80, isCenterAlign: true },
  { label: 'Success Conditions', field: 'successConditions', width: 180, formatter: (json: any) => json && JSON.stringify(json) },
  { label: 'Exclusive Kyes', field: 'exclusiveKeys', width: 180, formatter: (keys: string[]) => (keys || []).join(', ') },
  { label: 'Data', field: 'data', width: 180, formatter: (json: any) => json && JSON.stringify(json) },
];

export const AssignmentTriggerFieldValidatorProviderName = 'assignmentTriggerFieldValidator';
export const FirstRenewalCallPromoAbTest = 'first_renewal_call_promo';
export const OrderRidesMapBasedAbTest = 'order_rides_map_based';
export const NashDeliveryOperatorsAbTest = 'nash_delivery_operators';
export const BasicPlanRideLimitTestGroup = 'basic_plan_ride_limit_test';
export const FacebookValue60TestGroup = 'FacebookValue60';
export const ComparisonFramingAbTest = 'comparison_framing';
